/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export enum SipAgentContactTarget {
    ParamDtg = 11,
    ParamTgrp = 20,
}